export default "__VITE_ASSET__Dmsxnf_f__"